/**
 * @generated SignedSource<<f4fb46a82ad3d21e7ba4b8e248385383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersNewsletterSlideshowItemGetSizeNewsletter$data = {
  readonly newsletterCategories: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly shortDescription: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpersNewsletterSlideshowItemGetSizeNewsletter";
};
export type helpersNewsletterSlideshowItemGetSizeNewsletter$key = {
  readonly " $data"?: helpersNewsletterSlideshowItemGetSizeNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersNewsletterSlideshowItemGetSizeNewsletter">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersNewsletterSlideshowItemGetSizeNewsletter"
};

(node as any).hash = "b7c74e1ba6519a2d2634a23d5cbc619a";

export default node;
